import { Link } from "react-router-dom";

export default function InfoAgibilita() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8" data-testid="info-agibilita-page">
      <h1 className="section-title">Cos'è il Certificato di Agibilità</h1>
      <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground/80">
        <p>
          Il <strong className="text-bordeaux">certificato di agibilità</strong> è il documento previdenziale
          collegato alle prestazioni lavorative nel settore dello spettacolo. Riguarda artisti come cantanti,
          musicisti, D.J. e altri lavoratori dello spettacolo che si esibiscono presso locali ed eventi.
        </p>
        <p>
          Con ENPALSBOX puoi richiederlo online in pochi passaggi: ti iscrivi, compili il modulo con i dati del
          locale, la data dell'esibizione e l'importo pattuito, e invii la richiesta. Il nostro team la prende in
          carico e ti aggiorna sullo stato della pratica.
        </p>
        <p>
          Dopo l'invio riceverai una email di conferma con il numero di pratica e potrai seguire ogni
          aggiornamento dalla tua Area Personale, sezione "Le mie richieste".
        </p>
      </div>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/richiedi-agibilita" data-testid="info-agibilita-request-btn" className="btn-bordeaux">
          RICHIEDI CERTIFICATO DI AGIBILITÀ
        </Link>
        <Link to="/contatti" data-testid="info-agibilita-contact-btn" className="btn-outline-bordeaux">CONTATTACI</Link>
      </div>
    </div>
  );
}
